import React, { Fragment, Component } from 'react';
import './App.css';
import { ApiService } from './services/ApiService';
import Layout from './components/containers/Layout';
// import Main from './components/Main';
import baseTheme from './components/BaseTheme';
import {
  Contacts,
  Events,
  Home,
  Links,
  Maps,
  Notices,
  RssReader,
  TermDates,
  GeneralAlerts,
  Login
} from './components';

// router
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';

// material-ui
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme, CircularProgress, Grid } from '@material-ui/core';
// import TopBar from './components/TopBar';

const apiService = new ApiService();

const routes = {
  alerts: '/alerts',
  events: '/events',
  dashboard: '/',
  notices: '/notices',
  links: '/links',
  linksList: '/linksList',
  rssReader: '/rssReader',
  maps: '/maps',
  contacts: '/contacts',
  termDates: '/termDates',
  login: '/login'
}

class App extends Component {
  state = {
    alerts: [],
    alertItem: {},
    contacts: [],
    contactItem: {},
    contactsFilters: [],
    events: [],
    eventItem: {},
    links: [],
    linksFilters: [],
    linkItem: {},
    linksList: [],
    linksListFilters: [],
    linkListItem: {},
    maps: [],
    notices: [],
    noticeItem: {},
    rssFeeds: [],
    rssItem: {},
    termDates: [],
    settings: {},
    appLanguage: 'en',
    disabledModules: [],
    theme: {},
    isLoading: true,
  }

  componentDidMount() {
    // store intervalId in the state so it can be accessed later:
    // 900000 = 15mins, 1800000 = 30mins.
    const alertsIntervalId = setInterval(this.fetchGeneralAlerts, 400000);
    const eventsIntervalId = setInterval(this.fetchEvents, 1800000);
    const noticesIntervalId = setInterval(this.fetchNotices, 1800000);
        
    this.setState({isLoading: true});
    this.fetchSettings();
    Promise.all([
        this.fetchContacts(),
        this.fetchEvents(),
        this.fetchGeneralAlerts(),      
        this.fetchLinks(),
        this.fetchLinksList(),
        this.fetchMaps(),
        this.fetchNotices(),
        this.fetchRss(),
        this.fetchTermDates(),
        this.setState({
          alertsIntervalId: alertsIntervalId,
          eventsIntervalId: eventsIntervalId,
          noticesIntervalId: noticesIntervalId,
        }),
      ]).then(this.setState({isLoading: false}));
  }

  componentWillUnmount() {
    clearInterval(this.state.alertsIntervalId);
    clearInterval(this.state.eventsIntervalId);
    clearInterval(this.state.noticesIntervalId);
  }

  fetchContacts = () => {
    apiService.getContacts().then(contacts => {
      this.setState({
        contacts: contacts.items,
        contactsFilters: contacts.filters
      });
    });
  }

  fetchEvents = () => {
    apiService.getEvents().then(events => {
      this.setState({
        events: events.items,
        eventsFilters: events.filters
      });
    });
  }

  fetchGeneralAlerts = () => {
    // alerts to all 'general'
    // console.log('fetching Alerts');
    const categories = '&c=0';
    apiService.getAlerts(categories).then(alerts => {
      this.setState({alerts});
    });
  }

  fetchLinks = () => {
    apiService.getLinks().then(links => {
      // console.log(links.items)
      this.setState({
        links: links.items,
        linksFilters: links.filters
      });
    });
  }

  fetchLinksList = () => {
    apiService.getLinksList().then(linksList => {
      this.setState({
        linksList: linksList.items,
        linksListFilters: linksList.filters
      });
    });
  }

  fetchMaps = () => {
    apiService.getMaps().then(maps => {
      this.setState({maps});
    });
  }

  fetchNotices = () => {
    apiService.getNotices().then(notices => {
      this.setState({
        notices: notices.items,
        noticesFilters: notices.filters
      });
    });
  }

  fetchRss = () => {
    apiService.getRss().then(rssFeeds => {
      this.setState({rssFeeds});
    });
  }

  fetchTermDates = () => {
    apiService.getTermDates().then(termDates => {
      this.setState({termDates});
    });
  }

  fetchSettings() {
    apiService.getSettings().then(settings => {
      this.setState({
        settings,
        translations: settings.TRANSLATIONS,
        appLanguage: settings.APP_LANGUAGE ? settings.APP_LANGUAGE : 'en',
        enabledModules: settings.ENABLED_MODULES ? settings.ENABLED_MODULES : [],
        disabledModules: settings.DISABLED_MODULES ? settings.DISABLED_MODULES : [],
        portalSettings: settings.ENABLED_MODULES.portal,
        theme: createMuiTheme(baseTheme(settings.ENABLED_MODULES.portal.theme)),
        icon: apiService.getIcon()
      });
      this.isAuthenticated();
    });
  }

  handleRssItemSelected = id => {
    this.setState(({item}) => ({
      rssItem: item.find(item => item.id === id)
    }));
  }

  handleLinkItemSelected = id => {
    this.setState(({item}) => ({
      linkItem: item.find(item => item.id === id)
    }));
  }

  handleLinkListItemSelected = id => {
    this.setState(({item}) => ({
      linkListItem: item.find(item => item.id === id)
    }));
  }

  handleContactItemSelected = id => {
    this.setState(({contacts}) => ({
      contactItem: contacts.find(item => item.id === id)
    }));
  }

  handleNoticeItemSelected = id => {
    this.setState(({notices}) => ({
      noticeItem: notices.find(item => item.id === id)
    }));
  }

  handleAlertItemSelected = id => {
    this.setState(({alerts}) => ({
      alertItem: alerts.find(item => item.id === id)
    }));
  }

  handleEventItemSelected = id => {
    this.setState(({events}) => ({
      eventItem: events.find(item => item.id === id)
    }));
  }

  handleEventItemClose = () => {
    this.setState(({eventItem: {}}));
  }

  handleAlertItemClose = () => {
    this.setState(({alertItem: {}}));
  }

  handleNoticeItemClose = () => {
    this.setState(({noticeItem: {}}));
  }

  handleContactItemClose = () => {
    this.setState(({contactItem: {}}));
  }

  authenticate = (pass) => {
    if(this.state.portalSettings.passwordProtected === pass) {
      sessionStorage.setItem("auth", true);
      this.setState(({authenticated: true}));
      return false;
    } else {
      this.setState(({authenticated: false}));
      return false;
    }
  }

  isAuthenticated = () => {
    if(this.state.portalSettings.passwordProtected) {
      if(sessionStorage.getItem("auth")) {
        this.setState(({authenticated: true}));
      } else {
        this.setState(({authenticated: false}));
      }
    } else {
      this.setState(({authenticated: true}));
    }
  }

  checkDisabledModule = (name) => {
    return this.state.disabledModules.includes(name.replace(/^\w/, c => c.toUpperCase()));
  }

  checkEnabledModule = (name) => {
    const enabled = this.state.enabledModules.addModules.find(aModule => aModule.name === name);
    return enabled ? true : false;
  }

  portalModuleActive = (name) => {
    return this.state.portalSettings.modules.includes(name.replace(/^\w/, c => c.toLowerCase()));
  }

  isActiveModule = (name) => {
    const addedModules = ['termDates','linksList','rssReader'];
    if(addedModules.includes(name)) {
      return this.checkEnabledModule(name) && this.portalModuleActive(name);
    } else {
      return !this.checkDisabledModule(name) && this.portalModuleActive(name);
    }
  }

  render() {
    const {
      isLoading,
      alerts,
      alertItem,
      contacts,
      contactItem,
      contactsFilters,
      events,
      eventItem,
      eventsFilters,
      rssFeeds,
      rssItem,
      notices,
      noticeItem,
      noticesFilters,
      links,
      linksFilters,
      linkItem,
      linksList,
      linksListFilters,
      linkListItem,
      maps, 
      mapsFilters,
      settings,
      translations,
      appLanguage,
      enabledModules,
      portalSettings,
      termDates,
      icon,
    } = this.state;

    return (
      <Fragment>
        <CssBaseline />       
        {!translations || !appLanguage || !portalSettings || !enabledModules || isLoading ? 
          <Grid container justify='center' alignItems='center' style={{height: '100vh'}}>
            <Grid item >
              <CircularProgress />
            </Grid>
          </Grid>
        :
        <MuiThemeProvider theme={this.state.theme}>
            
        
          <BrowserRouter basename='/portal'>
            <div className="App">
              <Layout
                settings={settings}
                isActiveModule={this.isActiveModule}
                translations={translations}
                appLanguage={appLanguage}
                routes={routes}
                icon={icon}
              >
              { this.state.authenticated ?
                <Switch>
                  <Route exact path={routes.dashboard} render={
                    props => <Home {...props}
                        translations={translations}
                        appLanguage={appLanguage}
                        generalAlerts={alerts}
                        alertItem={alertItem}
                        events={events}
                        eventItem={eventItem}
                        notices={notices}
                        noticeItem={noticeItem}
                        links={links}
                        linksList={linksList}
                        rssFeeds={rssFeeds}
                        isActiveModule={this.isActiveModule}
                        routes={routes}
                        handleAlertItemSelected={this.handleAlertItemSelected}
                        handleAlertItemClose={this.handleAlertItemClose}
                        handleEventItemSelected={this.handleEventItemSelected}
                        handleEventItemClose={this.handleEventItemClose}
                        handleNoticeItemSelected={this.handleNoticeItemSelected}
                        handleNoticeItemClose={this.handleNoticeItemClose}
                      />
                  } />
                  {this.isActiveModule('contacts')
                    ? <Route path={routes.contacts} render={
                        props => <Contacts {...props}
                            contacts={contacts}
                            contactItem={contactItem}
                            filters={contactsFilters}
                            onRefreshData={this.fetchContacts}
                            onSelect={this.handleContactItemSelected}
                            onClose={this.handleContactItemClose}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('alerts')
                    ? <Route path={routes.alerts} render={
                        props => <GeneralAlerts {...props}
                            alerts={alerts}
                            alertItem={alertItem}
                            onRefreshData={this.fetchGeneralAlerts}
                            onSelect={this.handleAlertItemSelected}
                            onClose={this.handleAlertItemClose}
                            translations={translations}
                            appLanguage={appLanguage}
                            // filters={settings.ENABLED_MODULES ? settings.ENABLED_MODULES.events : null}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('links')
                    ? <Route path={routes.links} render={
                        props => <Links {...props}
                            moduleType='links'
                            links={links}
                            linkItem={linkItem}
                            onRefreshData={this.fetchLinks}
                            onSelect={this.handleLinkItemSelected}
                            filters={linksFilters}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('events')
                    ? <Route path={routes.events} render={
                        props => <Events {...props}
                            events={events}
                            eventItem={eventItem}
                            onRefreshData={this.fetchEvents}
                            type={enabledModules.events ? 'cals' : 'manual'}
                            filters={enabledModules.events ? enabledModules.events.calendars : eventsFilters ? eventsFilters : null}
                            onSelect={this.handleEventItemSelected}
                            onClose={this.handleEventItemClose}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('notices')
                    ? <Route path={routes.notices} render={
                        props => <Notices {...props}
                            notices={notices}
                            noticeItem={noticeItem}
                            onRefreshData={this.fetchNotices}
                            onSelect={this.handleNoticeItemSelected}
                            onClose={this.handleNoticeItemClose}
                            translations={translations}
                            appLanguage={appLanguage}
                            filters={noticesFilters}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('termDates')
                    ? <Route path={routes.termDates} render={
                        props => <TermDates {...props}
                            termDates={termDates}
                            onRefreshTermDates={this.fetchTermDates}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('rssReader')
                    ? <Route path={routes.rssReader} render={
                        props => <RssReader {...props}
                            rssFeeds={rssFeeds}
                            rssItem={rssItem}
                            onRefreshRssFeeds={this.fetchRss}
                            onSelect={this.handleRssItemSelected}
                            filters={enabledModules ? enabledModules.rssReader ? enabledModules.rssReader.feeds : null : null}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('linksList')
                    ? <Route path={routes.linksList} render={
                        props => <Links {...props}
                            moduleType='linksList'
                            links={linksList}
                            linkItem={linkListItem}
                            onRefreshData={this.fetchLinksList}
                            onSelect={this.handleLinkListItemSelected}
                            filters={linksListFilters}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  {this.isActiveModule('maps')
                    ? <Route path={routes.maps} render={
                        props => <Maps {...props}
                            links={maps}
                            onRefreshData={this.fetchMaps}
                            filters={mapsFilters ? mapsFilters : []}
                            translations={translations}
                            appLanguage={appLanguage}
                          />
                      }/>
                    : null
                  }
                  <Route>
                    <Redirect to="/"/>
                  </Route>
                </Switch>
                : 
                <Fragment>
                    {/* <Redirect to="/"/> */}
                  <Login open={!this.state.authenticated} auth={this.authenticate}></Login>
                </Fragment>
                }
              </Layout>
            </div>
          </BrowserRouter>        
        </MuiThemeProvider>
        }
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js